import { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { TopNav } from "@components/top-nav";

const MainLayout = ({ children }) => {
	const navRef = useRef(null);
	const location = useLocation();
	const [viewportHeight, setViewportHeight] = useState(0);



	const handleResize = () => {
		if (navRef.current) {  // 添加檢查確保 navRef.current 存在
			setViewportHeight(window.innerHeight - navRef.current.clientHeight);
		}
	};

	useEffect(() => {
		const app = document.getElementById("app");
		if (app) {
			app.scrollTo({ top: 0, behavior: "smooth" });
		}
	}, [location.pathname]);

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		setTimeout(handleResize, 0);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
	if (
		location.pathname.includes("/nps") ||
		location.pathname.includes("/vip/statements")
	) {
		return <>{children}</>;
	}
	return (
		<div
			id="app"
			className={"mx-auto flex min-h-screen max-w-[640px] flex-col"}
		>
			<TopNav ref={navRef} />
			<div>{children}</div>
		</div>
	);
};

export default MainLayout;
